function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from 'react';
var SvgComponent = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M18.3002 5.70996C18.1134 5.5227 17.8597 5.41747 17.5952 5.41747C17.3307 5.41747 17.077 5.5227 16.8902 5.70996L12.0002 10.59L7.11021 5.69996C6.92338 5.5127 6.66973 5.40747 6.40521 5.40747C6.1407 5.40747 5.88705 5.5127 5.70021 5.69996C5.31021 6.08996 5.31021 6.71996 5.70021 7.10996L10.5902 12L5.70021 16.89C5.31021 17.28 5.31021 17.91 5.70021 18.3C6.09021 18.69 6.72021 18.69 7.11021 18.3L12.0002 13.41L16.8902 18.3C17.2802 18.69 17.9102 18.69 18.3002 18.3C18.6902 17.91 18.6902 17.28 18.3002 16.89L13.4102 12L18.3002 7.10996C18.6802 6.72996 18.6802 6.08996 18.3002 5.70996Z",
    fill: "#9da3a8"
  }));
};
export default SvgComponent;
//# sourceMappingURL=close.js.map